import React from 'react';

import { useIntl } from '../../../../util/reactIntl';

import HeroSearchForm from './HeroSearchForm/HeroSearchForm';

import css from './SectionHero.module.css';

/**
 * Landing page hero section. A short solid-brand-colour band carrying the
 * keyword search form that navigates to the SearchPage on submit.
 *
 * The visible headline was removed (Week 3, Phase 2) to get listings on
 * screen sooner. The H1 stays in the markup, visually hidden: it is the
 * page's only H1, promoted for SEO at the client's request, and screen
 * readers still get a primary heading.
 *
 * @returns {JSX.Element}
 */
const SectionHero = () => {
  const intl = useIntl();

  return (
    <section className={css.root}>
      <div className={css.content}>
        <h1 className={css.visuallyHidden}>{intl.formatMessage({ id: 'SectionHero.headline' })}</h1>
        <HeroSearchForm />
      </div>
    </section>
  );
};

export default SectionHero;
